import { useContext, useState } from "react";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import instance from "@fetch/axios";
import { CartContext } from "@context/CardContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useAuth } from "@context/AuthContext";
import Spinner from "@components/Spinner";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "@fetch/axios";

const Component = () => {

  const { loadCartFromLocalStorage } = useContext(CartContext);
  const { translate } = useTranslation();
  const MySwal = withReactContent(Swal)
  const { lang, currency } = useContext(LanguageCurrencyContext);
  const { openAuth,closeAuth } = useAuth();
  const [loading, setLoading] = useState(true)

  // const googleLogin = () => {
  //   const redirect = encodeURIComponent(window.location.href);
  //   const cart     = localStorage.getItem('cart') ?? '[]';
  //   window.location.href = `${process.env.REACT_APP_BACKEND_URL}/google/login?lang=${lang}&currency=${currency}&redirect=${redirect}&cart=${encodeURIComponent(cart)}`;
  // };

  const googleLogin = useGoogleLogin({
    onSuccess: (response) => {
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${response.access_token}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${response.access_token}`
        },
      }).then((response) => {

        setLoading(false)

        instance.post('users/social-login?lang=' + lang, {
          google_id: response.data.id,
          name: response.data.given_name,
          lastname: response.data.family_name,
          email: response.data.email,
          photo: response.data.picture,
          lang: localStorage.getItem('lang_arteonu'),
          currency: currency,
          cart: JSON.parse(localStorage.getItem('cart') ?? '[]')
        }).then((response) => {

          let user = {
            affiliation: response.data.affiliation,
            email: response.data.email,
            name: response.data.given_name,
            country_id: response.data.country_id,
            lastname: response.data.family_name,
            phone: response.data.phone,
            code_phone: response.data.code_phone,
            date_birth: response.data.date_birth,
            verified: 1
          }
          localStorage.setItem('user_arteonu', JSON.stringify(user));
          localStorage.setItem('token_arteonu', response.data.api_token);
          localStorage.setItem('gg', response.data.gg);

          loadCartFromLocalStorage()

          setLoading(true)
          closeAuth()
          MySwal.fire({
            text: translate('login.rollback'),
            icon: 'success',
          }).finally(() => {
            window.location.reload();
          })


        }).catch((error) => {
          MySwal.fire({
            text: error.response.data,
            icon: 'error',
            title: 'Oops...'
          })
          console.log(error.response);
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    onError: (error) => {
      setLoading(true)
      console.log(error);
    },
  });

  const facebookLogin = (response) => {
    setLoading(false)
    if (response?.status !== 'unknown') {

      instance.post('users/social-login?lang=' + lang, {
        facebook_id: response.id,
        name: response.name,
        email: response.email,
        photo: response.picture?.data?.url,
        lang: localStorage.getItem('lang_arteonu'),
        currency: currency,
        cart: JSON.parse(localStorage.getItem('cart') ?? '[]')
      }).then((response) => {


        let user = {
            affiliation: response.data.affiliation,
            email: response.data.email,
            name: response.data.given_name,
            country_id: response.data.country_id,
            lastname: response.data.family_name,
            phone: response.data.phone,
            code_phone: response.data.code_phone,
            date_birth: response.data.date_birth,
            verified: 1
          }
          localStorage.setItem('user_arteonu', JSON.stringify(user));
          localStorage.setItem('token_arteonu', response.data.api_token);
          localStorage.setItem('gg', response.data.gg);

        loadCartFromLocalStorage()
        closeAuth()

        MySwal.fire({
          text: translate('login.rollback'),
          icon: 'success',
        }).finally(() => {
          window.location.reload();
        })

        setLoading(true)
       

      }).catch((error) => {
        setLoading(true)
        MySwal.fire({
          text: error.response.data,
          icon: 'error',
          title: 'Oops...'
        })
        console.error(error);
      });
    } else {
      setLoading(true)
      console.error(response);
    }
  }

  return (
    <>
      {!loading && <Spinner />}
      <div className="GroupButton">

        <div className="ButtonLightMini" onClick={() => googleLogin()}>
          <span className="IconGoogle">
            <i className="icon-GoogleRed"></i>
            <i className="icon-GoogleYellow"></i>
            <i className="icon-GoogleGreen"></i>
            <i className="icon-GoogleBlue"></i>
          </span>
          {translate('login.google')}
        </div>

        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          autoLoad={false}
          callback={facebookLogin}
          fields={"name,email,picture"}
          render={renderProps => (
            <div className="ButtonLightMini" onClick={renderProps.onClick}>
              <i className="icon-Facebook" style={{ color: "#1877f2" }}></i>
              {translate('login.facebook')}
            </div>
          )} />
        <div className="ButtonLightMini" onClick={() => openAuth('Login')}>
          <i className="icon-MailOpen"></i>
          {translate('login.wemail')}
        </div>
      </div>
    </>
  );
};

export default Component;
